import React from 'react'
import img2033 from '../components/images/iebay.png'

const events = () => {
    return (

        <>
            <div className="row  m-2">
                <img src={img2033} alt='ebay' />
            </div>
            <div className="row m-2">
                <div className="col-sm ">

                    <h2 className='p-2'>eBay Global Account Management Overview
                    </h2>
                    <p>Enhance your global presence on eBay with our expert account management services designed to boost sales and optimize visibility. </p>
                </div>
                <div className="col-sm ">
                    {/* <img src={img201} alt='Queryimg' /> */}
                </div>
            </div>
            <ul >
                <h3 className='text-info'> Key Services We Offer:</h3>
                <li><b>•	Product Listing:</b>Elevate visibility with expertly crafted product listings. </li>
                <li><b>•	Advertising Campaign:</b>Maximize reach and ROI through targeted ad strategies. </li>
                <li><b>•	Promotion:</b> Boost sales with effective promotional campaigns. </li>
                <li><b>•	Category Approval:</b> Ensure accurate categorization of your products. </li>
                <li><b>•	Account Health:</b> Maintain a healthy seller account to avoid issues. </li>
                <li><b>•	Order Processing:</b> Streamline order management for faster fulfillment. </li>
                <li><b>•	Payment Reconciliation:</b> Ensure accurate and timely payment processing. </li>
                <li><b>•	Keyword Optimization:</b> Improve search rankings with strategic keywords. </li>
                <li><b>•	Safety Claim:</b> Manage product safety and compliance efficiently. </li>
                <li><b>•	Basic Training:</b>Equip your team with essential eBay knowledge. </li>
                <li><b>•	Sales Boost:</b> Implement strategies for significant sales growth.</li>
            </ul>
        </>
    )
}

export default events